export interface ArxivPaperResponse {
  id: string;
  date: string;
  title: string;
  summary: string;
  link: string;
}

export function constructQuery(query: string, maxResults: number = 20): string {
  const base_url = "https://export.arxiv.org/api/query?search_query=";
  const search_terms = query.split(" ");

  let query_string = "";
  for (let i = 0; i < search_terms.length; i++) {
    if (query_string !== "") {
      query_string += "+AND+";
    }
    query_string += `all:${search_terms[i]}`;
  }

  return (
    base_url + query_string + `&start=0&max_results=${maxResults.toString()}`
  );
}

export function parseArxivSearchResponse(xmlAsText: any): ArxivPaperResponse[] {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xmlAsText, "application/xml");

  // Check for parsing errors
  const parseError = xmlDoc.getElementsByTagName("parsererror");
  if (parseError.length) {
    console.error("Error parsing XML");
    return []; // or handle the error appropriately
  }

  // Example: Extracting values from the XML
  const entries = xmlDoc.getElementsByTagName("entry");
  let papers: ArxivPaperResponse[] = [];
  for (let i = 0; i < entries.length; i++) {
    const id = entries[i].getElementsByTagName("id")[0].textContent;
    const title = entries[i].getElementsByTagName("title")[0].textContent;
    const summary = entries[i].getElementsByTagName("summary")[0].textContent;
    const date = entries[i].getElementsByTagName("updated")[0].textContent;

    const linkElement = entries[i].getElementsByTagName("link");
    let link = "";
    if (linkElement.length > 0) {
      for (let j = 0; j < linkElement.length; j++) {
        if (
          linkElement[j].getAttribute("rel") === "alternate" &&
          linkElement[j].getAttribute("type") === "text/html"
        ) {
          link = linkElement[j].getAttribute("href") || "";
          break;
        }
      }
    }

    // Only add the paper if all fields are non-null
    if (id && title && summary && date) {
      papers.push({
        id: id,
        title: title,
        summary: summary,
        date: date,
        link: link === "" ? "/#" : link,
      });
    }
  }

  return papers;
}
